module.exports = __webpack_public_path__ + "img/money_bag.e04ba001.svg";